<i-feather [name]="icon()!" [class]="class()" />